<template>
    <div class="company-staff-form-component">
        

        <table class="table">
            <thead>
                <tr>
                    <td>{{ 'staff_form.name' | translate }}</td>
                    <td>{{ 'staff_form.email' | translate }}</td>
                    <td>{{ 'staff_form.telephone' | translate }}</td>
                    <td></td>
                </tr>
            </thead>
            <tbody>

                <tr v-for="(staffItem, id) in staff" :key="id">
                    <td>
                        <input type="text" class="form-control" :class="{ 'is-invalid': !staffItem.name || (errors[id] && errors[id].name) }" v-model="staffItem.name" @input="staffItem.dirty = true" required>
                        <div v-if="errors[id] && errors[id].name" class="invalid-feedback">
                            {{ errors[id].name[0] }}
                        </div>
                    </td>
                    <td>
                        <input type="email" class="form-control" :class="{ 'is-invalid': !staffItem.email || (errors[id] && errors[id].email) }" v-model="staffItem.email" @input="staffItem.dirty = true" required>
                        <div v-if="errors[id] && errors[id].email" class="invalid-feedback">
                            {{ errors[id].email[0] }}
                        </div>
                    </td>
                    <td>
                        <input type="telephone" class="form-control" :class="{ 'is-invalid': errors[id] && errors[id].telephone }" v-model="staffItem.telephone" @input="staffItem.dirty = true">
                        <div v-if="errors[id] && errors[id].telephone" class="invalid-feedback">
                            {{ errors[id].telephone[0] }}
                        </div>
                    </td>
                    <td class="text-nowrap">
                        <button type="button" class="btn btn-danger" @click="remove(staffItem)"><i class="fa fa-trash"></i></button>
                        <button v-if="staffItem.dirty" type="button" class="btn btn-success" @click="update(staffItem)"><i class="fa fa-check"></i></button>
                    </td>
                </tr>

                <!-- add form -->
                <tr>
                <tr>
                    <td>
                        <label><b>{{ 'staff_form.new' | translate }}</b></label>
                        <input type="text" class="form-control" :class="{ 'is-invalid': add_form.name === '' || (errors.name) }" v-model="add_form.name" required>
                        <div v-if="errors.name" class="invalid-feedback">
                            {{ errors.name[0] }}
                        </div>
                    </td>
                    <td>
                        <label>&nbsp;</label>
                        <input type="email" class="form-control" :class="{ 'is-invalid': add_form.email === '' || (errors.email) }" v-model="add_form.email" required>
                        <div v-if="errors.email" class="invalid-feedback">
                            {{ errors.email[0] }}
                        </div>
                    </td>
                    <td>
                        <label>&nbsp;</label>
                        <input type="telephone" class="form-control" :class="{ 'is-invalid': errors.telephone }" v-model="add_form.telephone">
                        <div v-if="errors.telephone" class="invalid-feedback">
                            {{ errors.telephone[0] }}
                        </div>
                    </td>
                    <td>
                        <label class="w-100">&nbsp;</label>
                        <button type="button" class="btn btn-success" @click="add()"><i class="fa fa-plus"></i></button>
                    </td>
                </tr>
                
            </tbody>
        </table>


    </div>
</template>

<script>
    export default {
		name: 'company-staff-form',
		props: [
            'company',
            'loadUrl',
            'addUrl',
            'updateUrl',
            'removeUrl',
		],
		data() {
			return {
				csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                locale: window.default_locale,

                staff: {},
                add_form: {
                    name: null,
                    email: null,
                    telephone: null,
                },

                errors: {},
            }
        },
        created() {
            this.load();
        },
        methods: {

            load() {
				this.staff = [];

				this.showLoader();

                axios.post(this.loadUrl, {})
                .then(response => {
					this.hideLoader();
					
                    this.staff = _.keyBy(response.data.staff, 'id');
                }).catch(error => {
					this.hideLoader();

                    console.error(error);
                    Swal.fire({
                        icon: 'error',
                        title: this.translate('error'),
                    });
                });
            },

            add() {

                this.showLoader();

                axios.post(this.addUrl, this.add_form)
                .then(response => {
                    this.hideLoader();
                    
                    if(response.data.success) {
                        this.staff[response.data.staff.id] = response.data.staff;
                        this.add_form = {name: null, email: null, telephone: null};
                        this.errors = {};
                    }
                }).catch(error => {
                    this.hideLoader();

                    if(error && error.response && error.response.status == 422) {
                        if(error.response.data.errors) {
                            this.errors = error.response.data.errors;
                        }
                        if(error.response.data.message) {
                            Swal.fire({
                                icon: 'error',
                                title: error.response.data.message,
                            });
                        }
                    } else {
                        console.log(error);

                        Swal.fire({
                            icon: 'error',
                            title: this.translate('error'),
                        });
                    }
                });

            },

            update(staffItem) {

                this.showLoader();

                axios.post(this.updateUrl, {
                    staff_id: staffItem.id,
                    name: staffItem.name,
                    email: staffItem.email,
                    telephone: staffItem.telephone,
                })
                .then(response => {
                    this.hideLoader();
                    
                    if(response.data.success) {
                        // remove and add again
                        this.staff[response.data.staff.id] = response.data.staff;
                        this.errors = {};

                        Swal.fire({
                            icon: 'success',
                            title: this.translate('timeslot_form.success'),
                        });
                    }
                }).catch(error => {
                    this.hideLoader();

                    if(error && error.response && error.response.status == 422) {
                        if(error.response.data.errors) {
                            this.errors = {};
                            this.errors[staffItem.id] = error.response.data.errors;
                        }
                        
                        if(error.response.data.message) {
                            Swal.fire({
                                icon: 'error',
                                title: error.response.data.message,
                            });
                        }
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: this.translate('error'),
                        });
                    }
                });
            },

            remove(staffItem) {

                this.deleteConfirm.fire({
                    title: this.translate('staff_form.delete_confirm.title'), 
                    text: this.translate('staff_form.delete_confirm.text'),
                    // confirmButtonText: this.translate('staff_form.delete_confirm.confirm_button'),
                    // cancelButtonText: this.translate('staff_form.delete_confirm.cancel_button'),
                }).then((result) => {
                    if(result.value) {

                        this.showLoader();

                        axios.post(this.removeUrl, {
                            staff_id: staffItem.id
                        })
                        .then(response => {
                            this.hideLoader();
                            
                            if(response.data.success) {
                                Vue.delete(this.staff, response.data.staff_id);
                            }
                        }).catch(error => {
                            this.hideLoader();

                            Swal.fire({
                                icon: 'error',
                                title: this.translate('error'),
                            });
                        });

                    }
                });

            },

        }
    }
</script>